import { useRef } from 'react';
import Page from 'components/layout/Page';
import DailyHero from './sections/hero/DailyHero';
import DailyPricing from './sections/pricing/DailyPricing';
import DailyFeatures from './sections/features/DailyFeatures';
import DailyContact from './sections/contact/DailyContact';

const DailyCompaniesComponent: React.FC = () => {
  const contactRef = useRef<HTMLDivElement>(null);

  return (
    <Page hasScrollTop pageVariant="light">
      <DailyHero />
      <DailyFeatures contactRef={contactRef} />
      <DailyPricing />
      <DailyContact ref={contactRef} />
    </Page>
  );
};

export default DailyCompaniesComponent;
